"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_DESIGN_BASELINE_TOKENS = exports.APP_BASE_PUBLIC_THEME_DEFAULTS = void 0;
/**
 * The design tokens of the public surface of an AppBase: its theme defaults
 * and the base tokens. Only values, no contract: styles (vanilla-extract
 * files) import them without loading the App contract and its data model.
 */
const app_base_base_tokens_1 = require("./app-base-base-tokens");
exports.APP_BASE_PUBLIC_THEME_DEFAULTS = {
    '--color-brand': '#5090d3',
    '--color-brand-dark': '#3a7bbf',
    '--color-brand-light': '#a8d4ff',
    '--color-dark': '#0a0a0a',
    '--color-body': '#424149',
    '--color-muted': '#8696a7',
    '--color-border': '#e3e2e4',
    '--color-surface': '#f8f8fa',
    '--color-accent-green': '#6ee7b7',
    '--color-accent-red': '#fca5a5',
    '--font-display': '"Playfair Display", Georgia, serif',
    '--font-ui': '"Space Grotesk", system-ui, sans-serif',
    '--font-body': '"Outfit", system-ui, sans-serif',
    '--radius-card': '16px',
    '--radius-button': '10px',
    '--max-width-container': '1200px',
    '--max-width-prose': '680px',
    '--streamlain-v2-brand-primary': 'var(--color-brand)',
    '--streamlain-v2-text-primary': 'var(--color-dark)',
    '--streamlain-v2-text-secondary': 'var(--color-muted)',
    '--streamlain-v2-text-disable': '#b0b0b0',
    '--streamlain-v2-layer-background-primary': '#ffffff',
    '--streamlain-v2-layer-background-secondary': 'var(--color-surface)',
    '--streamlain-v2-layer-background-hoverOverlay': 'var(--color-surface)',
    '--streamlain-v2-layer-insideBorder-border': 'var(--color-border)',
    '--streamlain-v2-icon-primary': 'var(--color-muted)',
    '--streamlain-v2-status-error': '#dc2626',
    '--streamlain-v2-layer-background-error': '#fef2f2',
    '--streamlain-v2-status-success': '#16a34a',
};
exports.APP_BASE_DESIGN_BASELINE_TOKENS = {
    ...exports.APP_BASE_PUBLIC_THEME_DEFAULTS,
    ...app_base_base_tokens_1.APP_BASE_BASE_TOKEN_DEFAULTS,
};
